module.exports = __webpack_public_path__ + "img/icon-gift-bonus.ff250d62.svg";